import React from "react"

import countryParser from "../../helpers/countries"
import { CareerJobConverter } from "../careers-search/helpers/CareerSearchJobConverter"
import IconV2 from "../icon-v2"
import { CareersCardProps } from "./partials/CareerCardTypes"
import { StyledCareersCardContainer, StyledJobCardBlock, StyledJobCardTitle, StyledLocationLabel } from "./partials/StyledCareersCard"

const CareersCard = ({ title, location, department, jobType }: CareersCardProps) => (
  <StyledCareersCardContainer>
    <StyledJobCardBlock>
      <StyledJobCardTitle>{title}</StyledJobCardTitle>
      <p>{jobType}</p>
    </StyledJobCardBlock>
    <StyledJobCardBlock right>
      <StyledLocationLabel>
        <p style={{ paddingRight: "5px" }}>
          {`${countryParser[location] || location} `}
        </p>
        <IconV2 icon="map-marker-alt" />
      </StyledLocationLabel>
      <p style={{ paddingRight: "8px" }}>
        {department.map((dep) => CareerJobConverter[dep]).join(" • ")}
      </p>
    </StyledJobCardBlock>
  </StyledCareersCardContainer>
)

export default CareersCard
